import { z } from 'zod'
import QuestionWrapper from '../../questionnaire/formSteps/QuestionWrapper'

export const termOptions = [
  { label: '12 months', value: '12months' },
  { label: '24 months', value: '24months' },
  { label: '36 months', value: '36months' },
  { label: 'Unsure', value: 'unsure' },
]

export const termChoice = {
  component: QuestionWrapper,
  componentProps: {
    type: 'radio',
    title: "How long would you like your plan's term to be?",
    label: 'Plan preferences',
    subtitle: 'Select an option.',
    options: termOptions,
    formValue: 'termChoice',
    tooltip:
      'If you’re renting, we recommend choosing a contract that matches your lease length. If you own your home, a longer-term plan can help lock in your rate.',
    tracking: {
      stepName: 'Plan Term Length',
      deepStepNumber: 7,
      quickStepNumber: 7,
      deepStepId: '7',
      quickStepId: '7',
      fieldName: 'term_length',
    },
  },
  name: 'termChoiceRadioGroup',
  schema: z.object({
    termChoice: z.string().optional(),
  }),
}
